// Pagination
import { SECTION_HOMEPAGE } from '../sections';
const getPaginationParamPath = (section, param) => `pagination-${section}-${param}`;
export const getPaginationTypeParamPath = (section = SECTION_HOMEPAGE) => `style.numbers.${getPaginationParamPath(section, 'type')}`;
export const getPaginationPageSizeParam = (section = SECTION_HOMEPAGE) => getPaginationParamPath(section, 'pageSize');
export const getPaginationPageSizeParamPath = (section = SECTION_HOMEPAGE) => `style.numbers.${getPaginationPageSizeParam(section)}`;
//# sourceMappingURL=pagination.wix-params.js.map